

console.log("openCart: " + getUrlParameter("openCart"));
console.log("cupcake: " + getUrlParameter("cupcake"));

if(getUrlParameter("cupcake") == "1"){
  $(".product_detail").show();
}

let swimSize = 12;


function update_card_prices(){

   $(".ugw_card").each(function(){

      let accessoryFieldName = $(this).attr("data-accessory").trim();
      let selectElement = $(`select[name='${accessoryFieldName}']`);
      let currency = getSelectedCurrency().toLowerCase();
      let optionKey;

      if (currency == "cad") {
        optionKey = $(this).data("cad-" + swimSize + "-index");
      } else if (currency == "usd") {
        optionKey = $(this).data("us-" + swimSize + "-index");
      }

      console.log(currency+"-"+swimSize+"-index")
      console.log("optionKey:"+optionKey)

      let matchingOption = selectElement.find(
        `option[data-option_value_key='${optionKey}']`
      );
      if (matchingOption.length) {
        newValue = matchingOption.text();
      } else {
        console.warn(
          `No matching option for data-option_value_key="${optionKey}"`
        );
      }

      let bracketText = newValue.match(/\[(.*?)\]/);
      let finalText = bracketText ? bracketText[1] : '';

      console.log("ugw_salesPrice",finalText);

      // ✅ Update closest price element INSIDE this card
      $(this).find('.ugw_salesPrice').html(finalText);

    })

    $('.taper_card').each(function() {

      let $card = $(this); // ← store reference to current card
      let $select_main = $('select[name="properties[Taper]"]');
      let currency = getSelectedCurrency();
      let selected_index = "";

      selected_index = $card.data('option-value-key');
      console.log("taper selected_index:", selected_index);

      let $option = $select_main.find(
        `option[data-option_value_key="${selected_index}"]`
      );

      let optionText = $option.text();
      console.log("taper_card",optionText);

      let bracketText = optionText.match(/\[(.*?)\]/);
      let finalText = bracketText ? bracketText[1] : '';

      console.log(finalText);
      if(finalText == ""){
        finalText = "Included";
      }
      // ✅ Update closest price element INSIDE this card
      $card.find('.taper_price').html(finalText);

    });


    $('.capCover_card').each(function() {

      let $card = $(this); // ← store reference to current card
      let $select_main = $('select[name="properties[Cover Caps]"]');
      let currency = getSelectedCurrency();
      let selected_index = "";

      if (currency == "CAD"){
        selected_index = $card.data('cad-' + swimSize + '-index');
      }else{
        selected_index = $card.data('us-' + swimSize + '-index')
      }

      console.log("selected_index:", selected_index);

      let $option = $select_main.find(
        `option[data-option_value_key="${selected_index}"]`
      );

      let optionText = $option.text();
      console.log(optionText);

      let bracketText = optionText.match(/\[(.*?)\]/);
      let finalText = bracketText ? bracketText[1] : '';

      console.log(finalText);

      // ✅ Update closest price element INSIDE this card
      $card.find('.capCover_price').html(finalText);

    });
}


function getSelectedCurrency() {
  let cookies = document.cookie.split("; ");
  let currency = cookies.find((row) => row.startsWith("cart_currency="));
  return currency ? currency.split("=")[1] : "CAD";
}
 
function getPriceFromDropdown(optionKey) {
  let currency = getSelectedCurrency();
  let option = selectElement.find(
    `option[data-option_value_key='${optionKey}']`
  );
  if (!option.length) return "N/A";
  let priceMatch = option
    .text()
    .match(
      currency === "CAD" ? /\[\+\$(.*?) CAD\]/ : /\[\+\$(.*?) USD\]/
    );
  return priceMatch ? priceMatch[1] : "N/A";
}

function size_check() {
  console.log("size checked")
  const $el = $('#option-data');
  if (!$el.length) return null;

  const data = JSON.parse($el.attr('data-json'));
  const sizes = data.Size;

  let aSide = Number($(".input-a-value").val());
  let bSide = Number($(".input-b-value").val());
  let cSide = Number($(".input-c-value").val());
  console.log("a side:"+aSide)

  $('input[name="properties[Dimension A]"]').val(aSide);
  $('input[name="properties[Dimension B]"]').val(bSide);
  $('input[name="properties[Dimension C]"]').val(cSide);

  indexKey = 99;
  globe_max = 231;

  if(aSide > globe_max){
    alert("Size is to big please contact support");
    return;
  }

  for (let i = 0; i < sizes.length; i++) {
    let min = Number(sizes[i].min);
    let max = Number(sizes[i].max);
    let indexKey = Number(sizes[i].index_properties);

    
    if (min < aSide && aSide <= max) {

      console.log(min+":"+max)
      console.log("indexKey:"+indexKey)

      if (indexKey == 0){ swimSize = 12}
      else if  (indexKey == 1){ swimSize = 14}
      else if  (indexKey == 2){ swimSize = 15}
      else if  (indexKey == 3){ swimSize = 16}
      else if  (indexKey == 4){ swimSize = 17}
      else if  (indexKey == 5){ swimSize = 19}
      else if  (indexKey == 6){ swimSize = 21}

      console.log("size indexKey", indexKey)

      let $select = $('select[name="properties[size]"]');
      if (!$select.length) return;

      let  $option = $select.find(
        `option[data-option_value_key="${indexKey}"]`
      );

      console.log("$option", $option.text(), "indexKey", indexKey)
      if ($option.length) {
        console.log("length", $option.length, "option", $option.val())
        $select.val($option.val()).trigger('change');

        setTimeout(() => {
          $select[0].dispatchEvent(new Event("change", { bubbles: true }) );
          $select[0].dispatchEvent(new Event("input", { bubbles: true }));
          updatePrice()
        }, 100);
        
      }else{

        console.log("set default size");

        const select = document.querySelector('select[name="properties[size]"]');
        const option = select.querySelector('option[data-option_value_key="0"]');

        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
          updatePrice();
        }
      }
    }
  }

  $(".coverSize").text(`Current Size: ${swimSize}'`);

  updatedDisplayImg();
  setupPanelConfig();
  updatePrice()
  update_card_prices()
}

function updatedDisplayImg(){

  // Current selections
  let size  = swimSize;
  let taper = String($(".sdt_card.active").data("value")).replace(/-/g, "");
  let fold  = $('.fsk-foldType-length option:selected').val();
  let edge  = 'round';    // 'round' or 'cut'

  // Base CDN path
  const CDN_BASE = 'https://cdn.shopify.com/s/files/1/0575/1249/3261/files/';

  // Build filename
  function getImageUrl(size, taper, fold, edge) {
    if (fold === 'combo' && Number(size) === 17) {
      console.log("custom 16")
      size = 16;
    }

    let parts = [`${size}_${taper}`];

    if (fold === 'bi_folds') {
      parts.push('bi');
    }

    if (edge === 'cut') {
      parts.push('cut');
    }

    if (fold === 'combo') {
      parts.push('combo');
    }

    return CDN_BASE + parts.join('_') + '.png';
  }

  // Try image + graceful fallback
  function setProductImage() {
    let url = getImageUrl(size, taper, fold, edge);

    console.log("src",url)
    // Test image exists
    $("img.product-image.shape-image").attr("src",url)
  }
  
  // Run it
  setProductImage();

}

function setupPanelConfig() {

  let rawDataElement = $("#option-data");
    if (!rawDataElement.length) {
      return;
    }

  let rawData = rawDataElement.attr("data-json");
  let optionData = JSON.parse(rawData);

  let size = optionData.Size || [];

  const $select = $(".fsk-foldType-length");
  if (!$select.length) return;

  $select.empty();

  // 🔥 Find correct size object dynamically
  let sizeObj = size.find(s => s.name.replace("'", "") == swimSize);

  if (!sizeObj) {
    console.warn("Size not found:", swimSize);
    return;
  }

  let folds = sizeObj.folds;

  // Placeholder
  $select.append(
    $('<option>', {
      value: '',
      text: '-- Choose Panel Configuration --'
    })
  );

  // Dynamically append folds 
  folds.forEach(fold => {
    $select.append(
      $('<option>', {
        value: fold.value,
        text: fold.name,
        'data-index': fold.index
      })
    );
  });

}

function updateTaperSelection() {

    let currency = getSelectedCurrency();
    let rawDataElement = $("#option-data");
    if (!rawDataElement.length) {
      return;
    }

    let rawData = rawDataElement.attr("data-json");
    let optionData = JSON.parse(rawData);

    /* TAPPER */
    let tapers = optionData.Tapers || [];
    let container = $("#taperCardsContainer");

    container.empty();
    tapers.forEach((taper) => {
      let image_src = taper.image;
      let price = "";
      let fullprice = "";
      let value_key = taper.index_properties;
      
      let card = `
                <div class="sdt_card taper_card" 
                    data-value="${taper.handle}" 
                    data-option-value-key="${value_key}">
                    <img class="sdt_headerImg" src="${image_src}" alt="${taper.name}">
                    <div class="sdt_radioBtnContainer">
                        <div class="sdt_radio_icon"></div>
                        ${taper.name}
                    </div> 
                    <div class="sdt_discription">${taper.short}</div>
                    <div class="ugw_prices">
                      <div class="ugw_salesPrice taper_price"></div>
                  </div>
                </div>
                `;
      container.append(card);
    });



    var $hiddenForm = $(".product-form form"); // Hidden SC Products form
    var $hiddenQuantityInput = $hiddenForm.find("input[name='quantity']");
    if (!$hiddenQuantityInput.length) {
      $hiddenQuantityInput = $("<input>", {
        type: "number",
        name: "quantity",
        value: 1,
      }).appendTo($hiddenForm);
    } 

  $(".sdt_card").on("click", function () {
    $(".sdt_card").removeClass("active");
    $(this).addClass("active");

    let selectElement = $(`select[name="properties[Taper]"]`);
    let currency = getSelectedCurrency().toLowerCase();
    let optionKey = $(this).data("option-value-key");
    let matchingOption = selectElement.find(`option[data-option_value_key='${optionKey}']`);
    
    newValue = matchingOption.val();
    selectElement.val(newValue).trigger("change").trigger("input");

    // Force Shopify & SC Product Options to recognize the change
    selectElement[0].dispatchEvent(new Event("change", { bubbles: true }));
    selectElement[0].dispatchEvent(new Event("input", { bubbles: true }));
    updatePrice()
  });

    /* skirt length */
    console.log("skirt length")
    const $source = $('select[name="properties[Skirt Length]"]');
    const $target = $('#fsk-skirt-length');

    if (!$source.length || !$target.length) return;

    // Clear target first
    $target.empty();

    // Clone options
    $source.find('option').each(function () {
      const $opt = $(this);

      const $newOpt = $('<option>', {
        value: $opt.val(),
        text: $opt.text(),
        selected: $opt.is('[aria-selected="true"]') || $opt.is(':selected')
      });

      // Copy all data-* attributes
      $.each(this.attributes, function () {
        if (this.name.startsWith('data-')) {
          $newOpt.attr(this.name, this.value);
        }
      });

      $target.append($newOpt);
    });

    $target.on('change', function () {
      $source.val($(this).val()).trigger('change');


      setTimeout(() => {
        $source[0].dispatchEvent(new Event("change", { bubbles: true }) );
        $source[0].dispatchEvent(new Event("input", { bubbles: true }));
        updatePrice()
      }, 100);

    });

    /////////////////////////////////////////////
    /* measuement change *//////////////////////////
    ////////////////////////////////////////////

    $(".swim-dimension-input").on('change', function () {
      console.log("dimension change")
      size_check() 
    });

    /* fold change */


    $(".fsk-foldType-length").on('change', function () {
      let foldType = $(this).val();

      updatedDisplayImg()
      $fold_target =  $('select[name="properties[Fold]"]');
      $fold_target.val(foldType)

      let optionKey = $(this).find("option:selected").data("index");
      console.log("fold optionKey",optionKey)
      let matchingOption = $fold_target.find(`option[data-option_value_key='${optionKey}']`);
      newValue = matchingOption.val();
      console.log("fold newValue",newValue)
      $fold_target.val(newValue).trigger("change").trigger("input");

      setTimeout(() => {
        $fold_target[0].dispatchEvent(new Event("change", { bubbles: true }) );
        $fold_target[0].dispatchEvent(new Event("input", { bubbles: true }));
        updatePrice()
      }, 100);

    });

    /////////////////////////////////////////////
    /* add colors *//////////////////////////////
    /////////////////////////////////////////////

    let colours = optionData.Colour || [];
    let color_standard_container = $(".color-standard-container");
    let color_atlantis_container = $(".color-atlantis-container");
    let us_color_button_container = $(".us-color-button-container");
    let weatherShield_color_container = $(".weatherShield-color-container");

    color_standard_container.empty();
    color_atlantis_container.empty();

    us_color_button_container.empty();
    weatherShield_color_container.empty();

    function buildDataAttrs(obj, region) {
      const r = obj[region] || {};
      let attrs = "";

      if (r.ALL) {
        attrs += ` data-${region}-all-price="${r.ALL.price}"`;
        attrs += ` data-${region}-all-index="${r.ALL.index}"`;
      }

      Object.keys(r).forEach(k => {
        if (k === "ALL") return;
        attrs += ` data-${region}-${k}-price="${r[k].price}"`;
        attrs += ` data-${region}-${k}-index="${r[k].index}"`;
      });

      return attrs;
    }

    colours.forEach((Colour) => {

      let color_card = `
        <div
          class="color-button ${Colour.name}"
          data-propertie="${Colour.name_properties}"
          ${buildDataAttrs(Colour, "us")}
          ${buildDataAttrs(Colour, "cad")}
          data-color="${Colour.name.replace(/_/g, " ")}"
          data-image="${Colour.image}"
        >
          ${Colour.name.replace(/_/g, " ")}"
        </div>
      `;


      if(Colour.type == "fabric"){
        color_atlantis_container.append(color_card);
      }else if (Colour.type == "weatherShield"){
        weatherShield_color_container.append(color_card);
      }else if (Colour.type == "us-standard"){
        us_color_button_container.append(color_card);
      }else{
        color_standard_container.append(color_card);
      }
    });

    console.log("bind colors")
    bindColors();

    /////////////////////////////////////////////////
    /* handels highlights */
    /////////////////////////////////////////

    let handlesData = optionData.Handles || []; // Ensure Handles exist

    // Clear existing options
    console.log("add handels")
    $(".handle-options-container").empty();

    // Loop through each handle option and create the corresponding HTML
    handlesData.forEach((handle, index) => {
      let handlePrice = "";
      let value_key = "";

      let handleImage =
        handle.image !== ".jpg"
          ? `${handle.image}`
          : "https://cdn.shopify.com/s/files/1/0730/1467/3625/files/taper_img_1.png?v=1737347233";

      let price_promp = "Included"
      if(index == 1){
        price_promp = "Start at $39.99"
      }

      let handleCard = `
              <div class="shw_card" id="shwc_${index}" data-option="${index}" data-name="${handle.name}">
                  <img
                      class="shw_headerImg"
                      src="${handleImage}"
                      alt="${handle.name}"
                  >
                  <div class="shw_radioBtnContainer">
                      <div class="shw_radio_icon"></div> 
                      ${handle.name}
                  </div>
                  <div class="shw_discription">${handle.short}</div>
                  <div class="ugw_prices">
                    <div class="ugw_salesPrice capCover_price">${price_promp}</div>
                  </div>
              </div>
          `;

        // Append each handle card to the container
      $(".handle-options-container").append(handleCard);
    });

    const $handle_source = $('select[name="properties[Handles]"]');
    const $handle_target = $('.fsk-handel-count');

    if (!$handle_source.length || !$handle_target.length) return;

    // Clear target first
    $handle_target.empty();

    // Clone options
    $handle_source.find('option').each(function () {
      const $opt = $(this);

      const $newOpt = $('<option>', {
        value: $opt.val(),
        text: $opt.text(),
        selected: $opt.is('[aria-selected="true"]') || $opt.is(':selected')
      });

      // Copy all data-* attributes
      $.each(this.attributes, function () {
        if (this.name.startsWith('data-')) {
          $newOpt.attr(this.name, this.value);
          }
        });

        $handle_target.append($newOpt);
    });

  $("#handel-count-container").hide()
  bindHandles()

   /////////////////////////////////////////////////
    /* Cap Covers highlights */
    /////////////////////////////////////////

    let capData = optionData.Caps || []; // Ensure Handles exist

    // Clear existing options
    console.log("add Caps")
    $(".capCovers-options-container").empty();

    
    // Loop through each handle option and create the corresponding HTML
    capData.forEach((handle, index) => {
      let handlePrice = "";
      let value_key = "";

      let add_capData = true;
      if (currency == "CAD") {
        if (handle?.cad !== undefined) {
          console.log("capData CAD exists:", handle.cad);
          add_capData = true;
        }else{
          add_capData = false;
        }
      } else if (currency == "USD") {
        if (handle?.us !== undefined) {
          console.log("capData US exists:", handle.us);
          add_capData = true;
        }else{
          add_capData = false;
        }
      }
    
      if(add_capData){
        let handleCard = `
          <div class="capCover_card" 
              id="shwc_${index}" 
              data-option="${index}" 
              data-name="${handle.name}
              ${buildDataAttrs(handle, "us")}
              ${buildDataAttrs(handle, "cad")}
              ">
              <img
                  class="shw_headerImg"
                  src="${handle.image}"
                  alt="${handle.name}"
              >
              <div class="shw_radioBtnContainer">
                  <div class="shw_radio_icon"></div> 
                  ${handle.name}
              </div>
              <div class="shw_discription">${handle.short}</div>

              <div class="ugw_prices">
                <div class="ugw_salesPrice capCover_price"></div>
              </div>

          </div>
        `;

          // Append each handle card to the container
        $(".capCover-options-container").append(handleCard);
      } 
    });

   /////////////////////////////////////////////////
    /* Add Colors */
    /////////////////////////////////////////

  
    let cap_colours = optionData.Cap_Colour || [];
    let cap_color_atlantis_container = $(".cap-color-atlantis-container");

    cap_color_atlantis_container.empty();

    cap_colours.forEach((Colour) => {

      let color_card = `
        <div
          class="color-button ${Colour.name}"
          data-propertie="${Colour.name_properties}"
          ${buildDataAttrs(Colour, "us")}
          ${buildDataAttrs(Colour, "cad")}
          data-color="${Colour.name.replace(/_/g, " ")}"
          data-image="${Colour.image}"
        >
          ${Colour.name.replace(/_/g, " ")}"
        </div>
      `;
      

      if (currency == "CAD" && Colour.type=="fabric"){
        cap_color_atlantis_container.append(color_card);
      }else if (currency == "USD" && Colour.type=="weatherShield"){
        cap_color_atlantis_container.append(color_card);
      }

    });


  $(".cap-color-selector-widget").hide()
  bind_capCovers()


  /////////////////////////////////////////////////
  // Loop through each accessory
  ////////////////////////////////////////////

  let accessoriesData = optionData.Assessories || []; // Ensure Accessories exist

  // Clear existing options before inserting new ones
  $(".ugw_cardContainer").empty();

  // Loop through each accessory option and create the corresponding HTML
  accessoriesData.forEach((accessory, index) => {

    let currency = getSelectedCurrency();
    let price = "";
    let multi = false;
    let multi_class = "";
    
    if (accessory?.multi !== undefined) {
      multi = true;
      multi_class = "multi_class";
    }

    if (currency == "CAD") {
      if (accessory?.cad !== undefined) {
        console.log("cad exists:", accessory.cad,"multi",multi);
        if(multi){
          price = "hide";
        }else{
          price = accessory.cad[swimSize].price;
        }
        add_acc = true;
      }else{
        add_acc = false;
      }
    } else if (currency == "USD") {
      if (accessory?.us !== undefined) {
        if(multi){
          price = "hide";
        }else{
          price = accessory.us[swimSize].price;
        }
        add_acc = true;
      }else{
        add_acc = false;
      }
    }

    console.log("accessory.name",accessory.name,"price","$"+price);
  
    if(add_acc){
      let image_src = accessory.image;
      let accessoryCard = `
          <div class="ugw_card ${multi_class}" 
              data-multiClass="${multi_class}"
              data-accessory="${accessory.value}" 
              ${buildDataAttrs(accessory, "us")}
              ${buildDataAttrs(accessory, "cad")}
          >
              <img
                  class="ugw_headerImg"
                  src="${image_src}"
                  alt="${accessory.name}"
              >
              <div class="ugw_radioBtnContainer">
                  <div class="ugw_radio_icon"></div>
                  <div class="ugw_name">${accessory.name}</div>
              </div>
              <div class="ugw_discription">${accessory.short}</div>
              <div class="ugw_discription_long">${accessory.long}</div>
              <div class="ugw_prices">
                  <div class="ugw_salesPrice">$${price}</div>
              </div>
              <div class="ugw_select_container">
                  <select class="ugw_select ${multi_class}" data-accessory="${accessory.value}" >
                    <option>Okay</option>
                  </select>
              </div>
              <div class="ugw_popup_link">
                <div class="emu-link-icon"></div>
              </div>
          </div>
      `;
    

      // Append each accessory card to the container
      $(".ugw_cardContainer").append(accessoryCard);
    }

    $("select.ugw_select.multi_class").each(function () {

      let accessory_property = $(this).data("accessory");
   
      let $accessory_select = $(`select[name="${accessory_property}"]`);
      if ($accessory_select.length) {
        // Clear existing options first (optional)
        $(this).empty();
        // Clone options from source select
        $accessory_select.find("option").each((i, option) => {
          $(this).append($(option).clone());
        });
      }

    });

  });

  
  bindAccessories();
  bindpopup();

  update_card_prices();

}

function bindpopup(){
  $(document).on("click", ".ugw_popup_link", function (event) {
    event.stopPropagation(); // Prevent triggering body click
    console.log("popup clicked");
    let parentCard = $(this).closest(".ugw_card");

    let imageSrc = parentCard.find("img.ugw_headerImg").attr("src");
    let name = parentCard.find(".ugw_name").text();
    let description = parentCard.find(".ugw_discription_long").text();

    $("#ugw_popup_image").attr("src", imageSrc);
    $("#ugw_popup_name").text(name);
    $("#ugw_popup_description").text(description);

    $("#ugw_popup").css("display", "flex");
  });

  // Close popup when clicking close button
  $(document).on("click", ".ugw_close", function () {
    $("#ugw_popup").fadeOut();
  });

  // Close popup when clicking outside the popup content
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".ugw_popup_content").length &&
      $("#ugw_popup").is(":visible")
    ) {
      $("#ugw_popup").fadeOut();
    }
  });
}

function updateAccessories() {
  let currency = getSelectedCurrency().toLowerCase();
  $(".ugw_card").each(function () {
    $newPrice=""
    if (currency == "CAD") {
       newPrice = $(this).data("cad-" + swimSize + "-price");
    } else if (currency == "USD") {
       newPrice = $(this).data("us-" + swimSize + "-price");
    }

    $(this).find(".ugw_salesPrice").html("$"+newPrice+".00");
  });
}

function bindAccessories(){

  $(document).on("click", ".ugw_card", function () {

    let accessoryFieldName = $(this).attr("data-accessory").trim();
    let selectElement = $(`select[name='${accessoryFieldName}']`);
    let currency = getSelectedCurrency().toLowerCase();

    console.log(swimSize+":"+accessoryFieldName)

    if (!selectElement.length) {
      console.warn(`Dropdown not found for: ${accessoryFieldName}`);
      return;
    }

    if ($(this).hasClass("multi_class")) {
      console.log('muilt_drop');
      return;
    }
    
    // Toggle active state
    $(this).toggleClass("active");

    let newValue = "";
    if ($(this).hasClass("active")) {

      let optionKey;

       if (currency == "cad") {
          optionKey = $(this).data("cad-" + swimSize + "-index");
        } else if (currency == "usd") {
          optionKey = $(this).data("us-" + swimSize + "-index");
        }

      console.log(currency+"-"+swimSize+"-index")
      console.log("optionKey:"+optionKey)

      let matchingOption = selectElement.find(
        `option[data-option_value_key='${optionKey}']`
      );
      if (matchingOption.length) {
        newValue = matchingOption.val();
      } else {
        console.warn(
          `No matching option for data-option_value_key="${optionKey}"`
        );
      }
    }
    
    selectElement.val(newValue).trigger("change").trigger("input");

    // Force Shopify & SC Product Options to recognize the change
    selectElement[0].dispatchEvent(new Event("change", { bubbles: true }));
    selectElement[0].dispatchEvent(new Event("input", { bubbles: true }));
    updatePrice()

    console.log(
      `✅ ${accessoryFieldName} selection updated to: ${newValue}`
    );
    
  });

  $(document).on("change", "select.ugw_select.multi_class", function(){
      let property = $(this).data("accessory");
      let $select_main = $(`select[name="${property}"]`);

      let newValue = $(this).val();
      let $card = $(this).closest(".ugw_card.multi_class");

      if (!newValue) {
        $card.removeClass("active");
      } else {
        $card.addClass("active");
      }

      $select_main.val(newValue).trigger('change');

      console.log("property",property,"newValue",newValue)

      setTimeout(() => {
        $select_main[0].dispatchEvent(new Event("change", { bubbles: true }) );
        $select_main[0].dispatchEvent(new Event("input", { bubbles: true }));

        updatePrice()

      }, 100);
  }) 

}

function bindHandles(){
  $(".shw_card").on("click", function () {

    let indexKey;
    let $select_main_handel = $('select[name="properties[Handles]"]');
    let $select_ui_handel = $('.fsk-handel-count');

    $(".shw_card").removeClass("active");
    $(this).addClass("active");
    
    option_index = $(this).data("option")

    if(option_index==0){
      console.log("hide seletor")
      $(".fsk-handel-count").val("");
      indexKey="0";
      $("#handel-count-container").hide()
    }else{
      indexKey="1";
      $option_ui_handel = $select_ui_handel.find(
        `option[data-option_value_key="${indexKey}"]`
      );
      $select_ui_handel.val($option_ui_handel.val()).trigger('change');
      $("#handel-count-container").show()
    }

    /// set main 
   
    if (!$select_main_handel.length) return;

    let  $option_main_handel = $select_main_handel.find(
      `option[data-option_value_key="${indexKey}"]`
    );

    if ($option_main_handel.length) {
      $select_main_handel.val($option_main_handel.val()).trigger('change');

      setTimeout(() => {
        $select_main_handel[0].dispatchEvent(new Event("change", { bubbles: true }) );
        $select_main_handel[0].dispatchEvent(new Event("input", { bubbles: true }));
        updatePrice()
      }, 100);

    }
  })

  $(".fsk-handel-count").on('change', function () {

     let $select_main_handel = $('select[name="properties[Handles]"]');

     $select_main_handel.val($(this).val()).trigger('change');

    setTimeout(() => {
      $select_main_handel[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_main_handel[0].dispatchEvent(new Event("input", { bubbles: true }));
      updatePrice()
    }, 100);

  });

}

function bind_capCovers(){

  $(".capCover_card").on("click", function () {

    let $this = $(this);
    let $select_main = $('select[name="properties[Cover Caps]"]');
    let currency = getSelectedCurrency();
    let selected_index = "";
    
    // If already active → TURN OFF
    if ($this.hasClass("active")) {

      $this.removeClass("active");

      // Reset dropdown
      $select_main.val("").trigger("change");

      $(".cap-color-selector-widget").hide();

      setTimeout(() => {
        $select_main[0].dispatchEvent(new Event("change", { bubbles: true }));
        $select_main[0].dispatchEvent(new Event("input", { bubbles: true }));
        updatePrice();
      }, 100);

      return; // stop here
    }

    // Otherwise → normal behavior
    $(".capCover_card").removeClass("active");
    $this.addClass("active");

    let option_index = $this.data("option");

    if(option_index == 0){
      $(".cap-color-selector-widget").hide();
      $(".cap-color-selector-widget .color-button").removeClass("selected");
      $(".cap-color-selector-widget .dtext_target").html("");

      let $select_atlantis_cap_color = $('input[name="properties[Cover Cap Color]"]');
      $select_atlantis_cap_color.val("").trigger('change');

      setTimeout(() => {
        $select_atlantis_cap_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
        $select_atlantis_cap_color[0].dispatchEvent(new Event("input", { bubbles: true }));

        updatePrice()

      }, 100);
      
    } else {
      $(".cap-color-selector-widget").show();
    }

    if (currency == "CAD"){
      selected_index = $this.data('cad-' + swimSize + '-index');
    }else{
      selected_index = $this.data('us-' + swimSize + '-index');
    }

    console.log("selected_index:", selected_index);

    let $option = $select_main.find(
      `option[data-option_value_key="${selected_index}"]`
    );

    console.log("$option.val()", $option.val());

    $select_main.val($option.val()).trigger('change');

    setTimeout(() => {
      $select_main[0].dispatchEvent(new Event("change", { bubbles: true }));
      $select_main[0].dispatchEvent(new Event("input", { bubbles: true }));
      updatePrice();
    }, 100);

  });

  let $popup = $(".cap-cover.color-popup");

  $(".cap-color-selector-widget .color-button").hover(
    function (event) {
      console.log("cap color hover");
      let colorName = $(this).data("color");
      let imageUrl = $(this).data("image");

      // Update popup content
      $popup.text(colorName);
      $popup.css({
        "background-image": `url(${imageUrl})`,
        "display": "flex",
      });

      // Position the popup near the hovered button
      let offset = $(this).offset();
      $popup.css({
        "top": offset.top - 320 + "px",
        "left": offset.left + 50 + "px"
      });
    },
    function () {
      $popup.hide();
    }
  );

  $(".cap-color-selector-widget .color-button").on("click", function () {
    // Remove 'selected' class from all buttons and add it to the clicked one
    $(".cap-color-selector-widget .color-button").removeClass("selected");
    $(this).addClass("selected");
    let color_name = $(this).data("color");

    $(".cap-color-selector-widget .dtext_target").html(color_name);
    let $select_atlantis_cap_color = $('input[name="properties[Cover Cap Color]"]');

    $select_atlantis_cap_color.val(color_name).trigger('change');

    
    setTimeout(() => {
      $select_atlantis_cap_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_atlantis_cap_color[0].dispatchEvent(new Event("input", { bubbles: true }));

      updatePrice()

    }, 100);
    
    

  });

}

function bindColors(){

  let $popup = $("#color-popup");

  $(".color-button").hover(
    function (event) {
      let colorName = $(this).data("color");
      let imageUrl = $(this).data("image");

      // Update popup content
      $popup.text(colorName);
      $popup.css({
        "background-image": `url(${imageUrl})`,
        "display": "flex",
      });

      // Position the popup near the hovered button
      let offset = $(this).offset();
      $popup.css({
        "top": offset.top - 320 + "px",
        "left": offset.left + 50 + "px"
      });
    },
    function () {
      $popup.hide();
    }
  );

  $(".color-button").on("click", function () {
    // Remove 'selected' class from all buttons and add it to the clicked one
    $(".color-button").removeClass("selected");
    $(this).addClass("selected");
    let color_name = $(this).data("color");
    
    color_name = (color_name || "").replace(/_/g, " ");

    $(".dtext_target").html(color_name);
    let currency = getSelectedCurrency();
    let selected_index = 0;
    prop = $(this).data('propertie')

    if (currency == "CAD"){
      if( $(this).data('cad-all-index')){
        selected_index = $(this).data('cad-all-index')
      }else{
        selected_index = $(this).data('cad-'+swimSize+'-index')
      }
    }else{
       if( $(this).data('us-all-index')){
        selected_index = $(this).data('us-all-index')
      }else{
        selected_index = $(this).data('us-'+swimSize+'-index')
      }  
    }
    console.log("prop:"+prop);
    console.log("selected_index:"+selected_index);
    

    let $select_atlantis_color = $('select[name="properties[Atlantis Colours]"]');
    let $select_standard_color = $('select[name="properties[Colour]"]');
    let $select_weatherShield_color = $('select[name="properties[Weather Shield Colours]"]');

  
    if(prop == "properties[Atlantis Colours]"){
      let $option = $select_atlantis_color.find(
        `option[data-option_value_key="${selected_index}"]`
      );

      let optionText = $option.text();   // ← here
      console.log(optionText);
      optionText = (optionText || "").replace(/_/g, " ");
      $(".dtext_target").html(optionText);

      $select_atlantis_color.val($option.val()).trigger('change');
      $select_standard_color.val("");
      $select_weatherShield_color.val("");

    }else if(prop == "properties[Weather Shield Colours]"){
      let $option = $select_weatherShield_color.find(
        `option[data-option_value_key="${selected_index}"]`
      );

      let optionText = $option.text();   // ← here
      console.log(optionText);
      optionText = (optionText || "").replace(/_/g, " ");
      $(".dtext_target").html(optionText);

      $select_weatherShield_color.val($option.val()).trigger('change');
      $select_standard_color.val("");
      $select_atlantis_color.val("");

    }else{
      let $option = $select_standard_color.find(
        `option[data-option_value_key="${selected_index}"]`
      );

      let optionText = $option.text();   // ← here
      console.log(optionText);
      optionText = (optionText || "").replace(/_/g, " ");
      $(".dtext_target").html(optionText);

      $select_standard_color.val($option.val()).trigger('change');
      $select_atlantis_color.val("");
      $select_weatherShield_color.val("");
    }
    
    setTimeout(() => {
      $select_atlantis_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_atlantis_color[0].dispatchEvent(new Event("input", { bubbles: true }));

      $select_standard_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_standard_color[0].dispatchEvent(new Event("input", { bubbles: true }));

      $select_weatherShield_color[0].dispatchEvent(new Event("change", { bubbles: true }) );
      $select_weatherShield_color[0].dispatchEvent(new Event("input", { bubbles: true }));

      updatePrice()

    }, 100);
    
    
  });
  
}

function checkModels() {
  console.log("load json");

  // Safely retrieve JSON from the data attribute
  const brandDataElement = $("#brand-data").attr("data-json");

  if (!brandDataElement) {
    console.log("Brand data attribute not found!");
    return;
  }

  let brandData;
  try {
    brandData = JSON.parse(brandDataElement);
    console.log("Parsed brandData:", brandData);

    if (!Array.isArray(brandData)) {
      console.error("Brand data is not an array! Check metafield structure.");
      return;
    }
  } catch (e) {
    console.error("Error parsing JSON:", e);
    return;
  }

  // Populate the brand dropdown

  var selectedBrand = getUrlParameter("brand");
  var selectedModel = getUrlParameter("model");
  var selectedModel_ = selectedModel; // raw version

  if (selectedBrand) {
    selectedBrand = selectedBrand.replace(/-/g, " ");
  }

  if (selectedModel) {
    selectedModel = selectedModel.replace(/-/g, " ");
  }

  //thecoverbrothers.ca/products/custom-spa-cover?brand=Amish-Country&model=Paradise
  https: $.each(brandData, function (index, brand) {
    $("#brand").append(
      $("<option>", {
        value: brand.brand,
        text: brand.brand,
      })
    );
  });

  // Handle brand selection
  $("#brand").on("change", function () {
    const selectedBrand = $(this).val();
    const modelDropdown = $("#model");

    $('input[name="properties[Make]"]')
      .val(selectedBrand)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event

    // Reset and disable the model dropdown
    modelDropdown
      .html('<option value="">Select Model</option>')
      .prop("disabled", true);
    $("#details").hide();

    if (selectedBrand) {
      // Find the selected brand
      const brand = brandData.find((b) => b.brand === selectedBrand);

      if (brand && Array.isArray(brand.models)) {
        // Populate the model dropdown
        $.each(brand.models, function (index, model) {
          modelDropdown.append(
            $("<option>", {
              value: model.name,
              text: model.name,
            })
          );
        });

        modelDropdown.prop("disabled", false);

        $("#model").val(selectedModel);
        if (!$("#model").val()) {
          $("#model").val(selectedModel_);
        }

        $("#model").trigger("change");
      }
    }
  });

  // Handle model selection
  $("#model").on("change", function () {
    const selectedBrand = $("#brand").val();
    const selectedModel = $(this).val();

    $('input[name="properties[model]"]')
      .val(selectedModel)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event

    if (selectedBrand && selectedModel) {
      // Find the selected brand and model
      const brand = brandData.find((b) => b.brand === selectedBrand);
      const model = brand.models.find((m) => m.name === selectedModel);

      if (model) {
        // Display measurements
        const measurementsList = $("#measurements");
        measurementsList.empty();
        $.each(model.measurements, function (key, value) {
          measurementsList.append(`<li>${key.toUpperCase()}: ${value}</li>`);
          $(".input-" + key + "-value").val(value);
        });
        size_check();
      }
    } else {
      $("#details").hide();
    }
  });

  $("#brand").val(selectedBrand);
  $("#brand").trigger("change");
}

  function formcheck_setup(){

    $(".step-2-show").on("click", function () {
      let eMessage = "";

      console.log("check step 1");

      if ($(".sdt_card.active").length === 0) {
        eMessage += "select taper<br>";
      }

      if (!$(".input-a-value").val()) {
        eMessage += "add a dimension<br>";
      }

      if (!$(".input-b-value").val()) {
        eMessage += "add b dimension<br>";
      }

      if (!$(".input-c-value").val()) {
        eMessage += "add c dimension<br>";
      }

      if (!$(".emu-confirmation-checkbox").is(":checked")) {
        eMessage += "Must agree to measurements are accurate<br>";
      }

      if (eMessage === "") {

        $("#custom_step_01").hide();
        $("#custom_step_02").show();
        $(".errorMessage").html("").hide();

        // ✅ scroll to top
        $("html, body").animate({ scrollTop: 0 }, 400);

      } else {

        $(".errorMessage").html(eMessage).show();

        // ✅ scroll to error message instead (better UX)
        $("html, body").animate({
          scrollTop: $(".errorMessage").offset().top - 20
        }, 400);

      }
      });
    $(".next-step-btn").click(function(){

      let eMessage = "";
      let step = $(this).attr("current-step");

      if(step == 2){

        if($(".fsk-skirt-length").val() == ""){
          eMessage += "Select skirt length<br>";
        }

        if($(".fsk-foldType-length").val() == ""){
          eMessage += "Select Fold Type<br>";
        }

        if ($(".color-button.selected").length === 0) {
          eMessage += "Select Color<br>";
        }

        if (eMessage === "") {

          $("#custom_step_02").hide();
          $("#custom_step_03").show();
          $(".errorMessage").html("").hide();

          // ✅ Scroll to next step
          $("html, body").animate({
            scrollTop: $("#custom_step_03").offset().top - 20
          }, 400);

        } else {

          $(".errorMessage").html(eMessage).show();

          // ✅ Scroll to error message
          $("html, body").animate({
            scrollTop: $(".errorMessage").offset().top - 20
          }, 400);

        }
      }

    });
    
    $(".custom-add-to-cart").click(function () {
      $(".product-form__submit.bold_hidden").trigger("click");
    });
    
  }

  function updatePrice() {
      let getPriceRaw = $(".bold_option_total div span").html();
      let currency = getSelectedCurrency();
      console.log("getPriceRaw", getPriceRaw);

      if (!getPriceRaw) {
        $(".pct_total_price").html("$1,499.99 "+currency);
        return;
      }

      // clean string → remove $ and commas
      let numeric = parseFloat(
        getPriceRaw.replace(/[^0-9.]/g, "")
      );

      console.log("numeric", numeric);

      if (isNaN(numeric) || numeric < 500) {
        $(".pct_total_price").html("$1,499.99 "+currency);
      } else {
        $(".pct_total_price").html(getPriceRaw);
      }
  }

  $(document).ready(function () {
    console.log("Wait for product-form to load before running the script");
    let checkFormInterval = setInterval(() => {
      console.log(
        "check bold_option_textbox :" + $(".bold_option_textbox ").length
      );
      if ($(".bold_option_textbox ").length > 2) {
        clearInterval(checkFormInterval);
        updatePrice();
        updateTaperSelection();
        checkModels();
        formcheck_setup();
        size_check()
      }
    }, 500);

});

